import {CopyOutlined} from '@ant-design/icons'
import runAsync from '@/script/runAsync.mjs'
import {MessageIconButton} from './MessageButton.jsx'

export const MessageButtonCopy = ({message, props}) => {
    const onClick = async () => {
        const text = message.content.replace(
            /^(?:<think>.*?<\/think>\n*)?(.*)$/is,
            '$1'
        )

        await runAsync(
            () => navigator.clipboard.writeText(text),

            {
                action: '复制到剪贴板',
                loading: {show: false},
                success: {show: true},
            }
        )
    }

    return (
        <MessageIconButton
            title="复制"
            onClick={onClick}
            {...props}
        >
            <CopyOutlined />
        </MessageIconButton>
    )
}
